var _defs, _rect, _path, _path2, _rect2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPapColImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333 333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#0057a8;}.cls-3{fill:#022859;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 333,
    height: 333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.12,85.43H118.88a17,17,0,0,0-17,17v95.24a17,17,0,0,0,17,17h95.24a17,17,0,0,0,17-17V102.43A17,17,0,0,0,214.12,85.43ZM142.43,198.9a4.93,4.93,0,1,1,4.92-4.93A4.93,4.93,0,0,1,142.43,198.9Zm48.12,0a4.93,4.93,0,1,1,4.93-4.93A4.93,4.93,0,0,1,190.55,198.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.39,214.67v27.84a5.06,5.06,0,0,0,5.05,5.06h14.12a5.06,5.06,0,0,0,5.05-5.06V214.67Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.5,
    y: 108.6,
    width: 84,
    height: 42,
    rx: 3.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 166.49,
    cy: 178.17,
    r: 11.63
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPapColImg);
export default __webpack_public_path__ + "static/media/papColImg.2b9f3de630980a30f321d520f63da1d7.svg";
export { ForwardRef as ReactComponent };